import { withInstall } from '@/utils'
import CosFooterButton from './src/cosFooterButton.vue'
export default withInstall(CosFooterButton)
